import React, { FunctionComponent } from "react";
import { useIntl } from "react-intl";
import { Template } from "../../../../types/customization/template";
import { TemplateLocale } from "../../../../types/customization/common";
import { Configuration } from "../../../../types/customization/configuration";
import ProductOptions from "../../customization/ProductOptions";
import ConfirmModalSmily from "../ConfirmModalSmily";

import "./style.scss";

interface Props {
  configuration: Configuration | undefined;
  display: boolean;
  locale: TemplateLocale;
  onConfirm: () => void;
  onDismiss: () => void;
  template: Template;
}

const OptionChoiceModal: FunctionComponent<Props> = ({
  configuration,
  display,
  locale,
  onConfirm,
  onDismiss,
  template,
}) => {
  const intl = useIntl();

  return (
    <ConfirmModalSmily
      className="OptionChoiceModal"
      confirmLabel={intl.formatMessage({
        id: "kustom_LottieCarousel_button_next",
      })}
      display={display}
      onConfirm={onConfirm}
      onDismiss={onDismiss}
    >
      <>
        <div className="OptionChoiceModal-image" />
        <h2 className="OptionChoiceModal-title">
          {intl.formatMessage({ id: "kustom_OptionChoiceModal_title" })}
        </h2>
        <div className="OptionChoiceModal-content">
          <ProductOptions configuration={configuration} locale={locale} template={template} />
        </div>
      </>
    </ConfirmModalSmily>
  );
};

export default OptionChoiceModal;
